import { Injectable } from '@angular/core';
import posthog from 'posthog-js';

@Injectable({
  providedIn: 'root'
})
export class PostHogService {

  constructor() { }

  capture(label: string, properties?: any) {
    posthog.capture(label);
  }

  identify(email: string, properties?: any) {
    posthog.identify(email, properties);
  }

  reset() {
    posthog.reset();
  }
}
